/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ series: NonNullable<unknown>, number: NonNullable<unknown>, date: NonNullable<unknown>, name: NonNullable<unknown> }} Einvoice_Manual_Issued_Card_ByInputs */

const vi_einvoice_manual_issued_card_by = /** @type {(inputs: Einvoice_Manual_Issued_Card_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã xuất trên MISA: ${i?.series} · ${i?.number} · ${i?.date} — ${i?.name}`)
};

/**

* @param {Einvoice_Manual_Issued_Card_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_issued_card_by = /** @type {((inputs: Einvoice_Manual_Issued_Card_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_Issued_Card_ByInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_issued_card_by(inputs)
});